export class AuthService {
  public static async adminLogin(emailAddress: string, password: string, device: string): Promise<string> {
    return ''
  }

  public static async setLoginToken(token: string): Promise<void> {
    localStorage.setItem('access-token', token);
    // 828 this.storeLoginSession(true);
  }

  public static async logout(): Promise<void> {
    localStorage.removeItem('access-token');
    // 828 this.storeLoginSession(false);
    // 828 await BaseService.proximaClient.clearStore();
  }

  /*
  private static storeLoginSession(isLoggedIn: boolean): void {
    BaseService.proximaClient.writeQuery({
      query: gql`
        query AuthSession($id: Int!) {
          authSession(id: $id) {
            id
            isLoggedIn
          }
        }
      `,
      data: {
        authSession: {
          __typename: 'AuthSession',
          id: 1,
          isLoggedIn: isLoggedIn
        }
      },
      variables: {
        id: 1
      }
    });
  }

  public static getLoginSession(): AuthSession {
    const response = BaseService.proximaClient.readQuery({
      query: gql`
        query AuthSession($id: ID!) {
          authSession(id: $id) {
            isLoggedIn
          }
        }
      `,
      variables: {
        // Provide any required variables here
        id: 1
      }
    });
    if (!response) {
      return {
        isLoggedIn: false
      };
    }
    return (response as any).authSession as AuthSession;
  }

   */
}
